import * as React from "react";
import ReportTabView from 'src/components/reports';
import { UserProfileProps, withUserProfile } from "../../components/user-profile";
import {connect} from 'redux-scaffolding-ts';
import { EmployeeCompanyStore, ReportEmployeesStore } from "src/stores/employees-store";
import { EmployeesReportStore } from "src/stores/employee-report-store";
import autobind from "autobind-decorator";
import { formatMessage } from "src/core/services/http.service";



interface MyReportsViewProps extends UserProfileProps {
    companyId: string,
    companyTitle: string,
    employeeTitle: string,
    employeeId: string,
    currency: string,
    allowCir: boolean,
    allowCii: boolean,
}

interface MyReportsViewState {
    error?: string;
    isBusy: boolean;
    isAdmin: boolean;
    isManager: boolean;
}


@connect(['employees', EmployeesReportStore])
class MyReportsView extends React.Component<MyReportsViewProps, MyReportsViewState> {

    constructor(props: MyReportsViewProps) {
        super(props);
        this.state = {
            isBusy: false,
            isAdmin: false,
            isManager: false
        };
    }

    private get employeesStore() {
        return (this.props as any).employees as EmployeesReportStore;
    }

    componentWillMount() {
        this.loadRoles(this.props.employeeId)
    }

    @autobind
    private loadRoles(userId: string){
            this.setState({ isBusy: true });
            this.employeesStore.changeUserUrlBase(this.props.companyId)
            this.employeesStore.getEmployeesRoles(userId).then(result => {
                this.setState({
                    isBusy: false,
                    isAdmin: result.firstOrDefault(x=> x == "Administrator") != null,
                    isManager: result.firstOrDefault(x=> x == "Manager") != null
                });
            }).catch(error => {
                this.setState({ error: formatMessage(error), isBusy: false })
            });
        }

    

    public render() {
        var isAdmin = this.state.isAdmin || this.props.userProfile.roles.includes("FIConsultant") || this.props.userProfile.roles.includes("ClientAdmin");;
        var isManager = this.state.isManager

        var companyId = this.props.companyId
        var companyTitle = this.props.companyTitle
        var employeeId = this.props.employeeId
        var employeeTitle = this.props.employeeTitle
        var currency = this.props.currency
        var allowCir = this.props.allowCir
        var allowCii = this.props.allowCii
        return (
            <React.Fragment>
                <ReportTabView companyId={companyId} companyName={companyTitle} isAdmin={isAdmin} employeeId={employeeId} currency={currency} allowCir={allowCir} allowCii={allowCii} isManager={isManager} />
            </React.Fragment>

        );
    }
}

export default withUserProfile(MyReportsView);
